import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'

@Pipe({
  name: 'safeUrl',
  standalone: false,
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeUrl {
    // This method uses Angular's DomSanitizer to mark the URL as trusted.
    // It is crucial to use this method to avoid security vulnerabilities,
    // such as cross-site scripting (XSS), which can occur if an untrusted URL is used directly.
    return this.sanitizer.bypassSecurityTrustUrl(url)
  }
}
